import React from "react";
import { FaEnvelope, FaPhoneAlt, FaPaperPlane, FaSpinner } from "react-icons/fa";
import styles from "../ReferralPage.module.css";

const ReferralForm = ({
    referralEmail,
    referralPhone,
    isLoading,
    message,
    isError,
    animateForm,
    handleSubmit,
    handleEmailChange,
    handlePhoneChange
}) => {
    return (
        <div className={`${styles.formCard} ${animateForm ? styles.animate : ''}`}>
            <div className={styles.cardHeader}>
                <h2>Send a Direct Invitation</h2>
            </div>
            <form onSubmit={handleSubmit}>
                <div className={styles.inputContainer}>
                    <label htmlFor="referralEmail">
                        Email Address <span className={styles.required}>*</span>
                    </label>
                    <div className={styles.inputGroup}>
                        <FaEnvelope className={styles.inputIcon} />
                        <input
                            type="email"
                            id="referralEmail"
                            name="referralEmail"
                            placeholder="Enter your friend's email"
                            value={referralEmail}
                            onChange={handleEmailChange}
                            required
                            disabled={isLoading}
                        />
                    </div>
                </div>

                <div className={styles.inputContainer}>
                    <label htmlFor="referralPhone">Phone Number (Optional)</label>
                    <div className={styles.inputGroup}>
                        <FaPhoneAlt className={styles.inputIcon} />
                        <input
                            type="tel"
                            id="referralPhone"
                            name="referralPhone"
                            placeholder="Enter their phone number"
                            value={referralPhone}
                            onChange={handlePhoneChange}
                            disabled={isLoading}
                        />
                    </div>
                </div>

                {message && (
                    <p className={isError ? styles.errorText : styles.successText}>
                        {message}
                    </p>
                )}

                <button
                    type="submit"
                    className={`${styles.btn} ${styles.btnPrimary}`}
                    disabled={isLoading || !referralEmail}
                >
                    {isLoading ? <FaSpinner className={styles.spinner} /> : <FaPaperPlane />}
                    {isLoading ? 'Sending Invitation...' : 'Send Invitation'}
                </button>
            </form>
        </div>
    );
};

export default ReferralForm;
